/*

 * ============================================================

 * ANTE VINTAGE TOKYO

 * SEARCH ENGINE V6

 * ============================================================

 *

 * V6

 * - Shopify標準form submitを維持

 * - title: によるモデル単独検索はしない

 * - 日本語 / 英語の表記揺れを統一

 * - Small -> SM

 * - Medium -> MM

 * - Large -> LM

 * - Pink Gold / Rose Gold -> PG

 * - 複合条件は AND でShopifyへ渡す

 * - 型番など辞書外検索は変更しない

 *

 * Examples:

 *

 * Tank Louis

 * -> Tank Louis

 *

 * Tank Louis Small

 * -> "Tank Louis" AND SM

 *

 * マストタンク アイボリー

 * -> "マストタンク" AND アイボリー

 *

 * Must Tank SM Ivory

 * -> "Must Tank" AND SM AND Ivory

 *

 * ============================================================

 */



(function () {

  "use strict";





  /* =========================================================

     NORMALIZE

     ========================================================= */



  function normalize(value) {

    if (!value) return "";



    return String(value)
      .normalize("NFKC")
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[・･\-‐‑‒–—―_]/g, "")
      .replace(/[."'’`]/g, "")
      .trim();

  }





  function getDictionary() {

    return window.ANTE_SEARCH_DICTIONARY || null;

  }





  function getCandidates(item) {

    var result = [];



    if (item && Array.isArray(item.aliases)) {

      result = item.aliases.slice();

    }



    if (item && item.canonical) {

      result.push(item.canonical);

    }



    return result;

  }





  /* =========================================================

     MATCH

     ========================================================= */



  function findBestContained(query, items) {

    if (!query || !Array.isArray(items)) return null;



    var q = normalize(query);

    var best = null;

    var bestLength = 0;





    items.forEach(function (item) {



      getCandidates(item).forEach(function (candidate) {



        var c = normalize(candidate);



        if (

          c &&

          q.indexOf(c) !== -1 &&

          c.length > bestLength

        ) {

          best = item;

          bestLength = c.length;

        }



      });



    });





    return best;

  }





  /* =========================================================

     LANGUAGE

     ========================================================= */



  function isJapanesePage() {

    var lang =

      (document.documentElement.lang || "")

        .toLowerCase();



    return lang.indexOf("ja") === 0;

  }





  /* =========================================================

     MODEL TERMS

     ========================================================= */



  var MODEL_TERMS = {



    /* CARTIER */



    "panthere": {

      ja: "パンテール",

      en: "Panthere"

    },



    "panthere-cougar": {

      ja: "クーガ",

      en: "Cougar"

    },



    "must-tank": {

      ja: "マストタンク",

      en: "Must Tank"

    },



    "pre-must-tank": {

      ja: "プレマスト",

      en: "Pre Must"

    },



    "tank-louis": {

      ja: "タンクルイ",

      en: "Tank Louis"

    },



    "tank-francaise": {

      ja: "タンクフランセーズ",

      en: "Tank Francaise"

    },



    "tank-americaine": {

      ja: "タンクアメリカン",

      en: "Tank Americaine"

    },



    "tank-anglaise": {

      ja: "タンクアングレーズ",

      en: "Tank Anglaise"

    },



    "tank-basculante": {

      ja: "タンクバスキュラント",

      en: "Tank Basculante"

    },



    "tank-solo": {

      ja: "タンクソロ",

      en: "Tank Solo"

    },



    "baignoire": {

      ja: "ベニュワール",

      en: "Baignoire"

    },



    "baignoire-allongee": {

      ja: "アロンジェ",

      en: "Allongee"

    },



    "santos-galbee": {

      ja: "ガルベ",

      en: "Santos Galbee"

    },



    "santos-octagon": {

      ja: "オクタゴン",

      en: "Santos Octagon"

    },



    "santos-demoiselle": {

      ja: "ドゥモワゼル",

      en: "Santos Demoiselle"

    },



    "santos-dumont": {

      ja: "デュモン",

      en: "Santos Dumont"

    },



    "ballon-bleu": {

      ja: "バロンブルー",

      en: "Ballon Bleu"

    },



    "tortue": {

      ja: "トーチュ",

      en: "Tortue"

    },



    "trinity": {

      ja: "トリニティ",

      en: "Trinity"

    },



    "roadster": {

      ja: "ロードスター",

      en: "Roadster"

    },



    "vendome": {

      ja: "ヴァンドーム",

      en: "Vendome"

    },



    "colisee": {

      ja: "コリゼ",

      en: "Colisee"

    },



    "pasha": {

      ja: "パシャ",

      en: "Pasha"

    },



    "diabolo": {

      ja: "ディアボロ",

      en: "Diabolo"

    },



    "tonneau": {

      ja: "トノー",

      en: "Tonneau"

    },



    "ronde": {

      ja: "ロンド",

      en: "Ronde"

    },





    /* JAEGER-LECOULTRE */



    "reverso": {

      ja: "レベルソ",

      en: "Reverso"

    },



    "reverso-duetto": {

      ja: "レベルソ デュエット",

      en: "Reverso Duetto"

    },



    "reverso-classique": {

      ja: "レベルソ クラシック",

      en: "Reverso Classique"

    },





    /* FRANCK MULLER */



    "casablanca": {

      ja: "カサブランカ",

      en: "Casablanca"

    },



    "long-island": {

      ja: "ロングアイランド",

      en: "Long Island"

    },



    "tonneau-curvex": {

      ja: "トノーカーベックス",

      en: "Tonneau Curvex"

    },



    "color-dreams": {

      ja: "カラードリーム",

      en: "Color Dreams"

    },



    "vegas": {

      ja: "ヴェガス",

      en: "Vegas"

    },



    "conquistador": {

      ja: "コンキスタドール",

      en: "Conquistador"

    },





    /* ROLEX */



    "datejust": {

      ja: "デイトジャスト",

      en: "Datejust"

    },



    "oyster-perpetual": {

      ja: "オイスターパーペチュアル",

      en: "Oyster Perpetual"

    },



    "cellini": {

      ja: "チェリーニ",

      en: "Cellini"

    },





    /* PATEK PHILIPPE */



    "calatrava": {

      ja: "カラトラバ",

      en: "Calatrava"

    },



    "golden-ellipse": {

      ja: "ゴールデンエリプス",

      en: "Golden Ellipse"

    },





    /* HERMES */



    "nantucket": {

      ja: "ナンタケット",

      en: "Nantucket"

    },



    "cape-cod": {

      ja: "ケープコッド",

      en: "Cape Cod"

    },



    "heure-h": {

      ja: "Hウォッチ",

      en: "Heure H"

    },



    "kelly": {

      ja: "ケリー",

      en: "Kelly"

    }



  };





  /* =========================================================

     GROUP TERMS

     ========================================================= */



  var GROUP_TERMS = {



    "must-family": {

      ja: "マスト",

      en: "Must"

    },



    "tank-family": {

      ja: "タンク",

      en: "Tank"

    },



    "santos-family": {

      ja: "サントス",

      en: "Santos"

    }



  };





  /* =========================================================

     SIZE TERMS

     ========================================================= */



 var SIZE_TERMS = {



  mini: {

    ja: "ミニ",

    en: "Mini"

  },



  sm: {

    ja: "SM",

    en: "Small"

  },



  mm: {

    ja: "MM",

    en: "Medium"

  },



  lm: {

    ja: "LM",

    en: "Large"

  },



  xl: {

    ja: "XL",

    en: "XL"

  }



};

  /* =========================================================

     MATERIAL TERMS

     ========================================================= */



  var MATERIAL_TERMS = {



    yg: {

      ja: "YG",

      en: "YG"

    },



    wg: {

      ja: "WG",

      en: "WG"

    },



    pg: {

      ja: "PG",

      en: "PG"

    },



    ss: {

      ja: "SS",

      en: "SS"

    },



    "two-tone": {

      ja: "コンビ",

      en: "Two Tone"

    }



  };





  /* =========================================================

     DIAL COLOR TERMS

     ========================================================= */



  var DIAL_TERMS = {



    ivory: {

      ja: "アイボリー",

      en: "Ivory"

    },



    white: {

      ja: "ホワイト",

      en: "White"

    },



    black: {

      ja: "ブラック",

      en: "Black"

    },



    blue: {

      ja: "ブルー",

      en: "Blue"

    },



    burgundy: {

      ja: "ボルドー",

      en: "Burgundy"

    },



    red: {

      ja: "レッド",

      en: "Red"

    },



    silver: {

      ja: "シルバー",

      en: "Silver"

    },



    champagne: {

      ja: "シャンパン",

      en: "Champagne"

    },



    gold: {

      ja: "ゴールド文字盤",

      en: "Gold"

    },



    grey: {

      ja: "グレー",

      en: "Grey"

    }



  };





  /* =========================================================

     LOCALIZED TERM

     ========================================================= */



  function localizedTerm(map, id) {

    if (!map[id]) return "";



    return isJapanesePage()

      ? map[id].ja

      : map[id].en;

  }





  /* =========================================================

     ANALYZE

     ========================================================= */



  function analyze(rawQuery) {



    var dict = getDictionary();





    var result = {



      original: rawQuery,



      model: null,



      group: null,



      size: null,



      material: null,



      dialColor: null



    };





    if (!dict) return result;





    result.model =

      findBestContained(

        rawQuery,

        dict.models || []

      );





    /*

     Parent group only if

     no specific model was found.

    */



    if (!result.model) {



      result.group =

        findBestContained(

          rawQuery,

          dict.groups || []

        );



    }





    result.size =

      findBestContained(

        rawQuery,

        dict.sizes || []

      );





    result.material =

      findBestContained(

        rawQuery,

        dict.materials || []

      );





    result.dialColor =

      findBestContained(

        rawQuery,

        dict.dialColors || []

      );





    return result;



  }





  /* =========================================================

     QUOTE

     ========================================================= */



  function quotePhrase(value) {



    return '"' +

      String(value)

        .replace(/\\\\/g, "\\\\\\\\")

        .replace(/"/g, '\\\\"') +

      '"';



  }





  /* =========================================================

     BUILD QUERY

     ========================================================= */



 function buildQuery(rawQuery) {



  if (!rawQuery) {

    return "";

  }



  var original =

    String(rawQuery).trim();



  var analysis =

    analyze(original);



  /*

   * モデルを辞書で特定できない場合は、

   * 入力をそのままShopifyへ送る。

   *

   * 型番・ブランド名・自由検索などを壊さない。

   */

  if (

    !analysis ||

    !analysis.model ||

    !MODEL_TERMS[analysis.model.id]

  ) {

    return original;

  }





  var model =

    analysis.model;



  var canonicalModel =

    localizedTerm(

      MODEL_TERMS,

      model.id

    );





  /*

   * 入力されたモデル名部分だけを取り除き、

   * Small / SM / Ivory / YG など

   * その他の入力はそのまま残す。

   */

  var remainder =

    original;



  var aliases = [];



  if (

    Array.isArray(model.aliases)

  ) {

    aliases =

      model.aliases.slice();

  }



  if (model.canonical) {

    aliases.push(

      model.canonical

    );

  }





  /*

   * 長いaliasから先に処理する。

   *

   * 例:

   * "JLC Reverso" を

   * "Reverso" より先に除去する。

   */

  aliases.sort(

    function (a, b) {

      return (

        String(b).length -

        String(a).length

      );

    }

  );





  for (

    var i = 0;

    i < aliases.length;

    i++

  ) {



    var alias =

      String(aliases[i] || "")

        .trim();



    if (!alias) {

      continue;

    }



    /*

     * 正規表現の特殊文字をエスケープ

     */

    var escaped =

      alias.replace(

        /[.*+?^${}()|[\\]\\\\]/g,

        "\\\\$&"

      );



    var regex =

      new RegExp(

        escaped,

        "i"

      );



    if (regex.test(remainder)) {



      remainder =

        remainder.replace(

          regex,

          " "

        );



      break;

    }



  }





  /*

   * 余分なスペースだけ整理。

   */

  remainder =

    remainder

      .replace(/\s+/g, " ")

      .trim();





  /*

   * モデル単独検索

   *

   * Reverso

   * → Reverso

   *

   * レベルソ

   * → レベルソ

   */

  if (!remainder) {

    return canonicalModel;

  }





  /*

   * 複合検索

   *

   * Tank Louis Small

   * → Tank Louis Small

   *

   * Tank Louis SM

   * → Tank Louis SM

   *

   * JLC Reverso Small

   * → Reverso Small

   *

   * Must de Cartier Tank Ivory

   * → Must Tank Ivory

   *

   * Small / SM / Ivory / YG 等は

   * 強制変換しない。

   */

  return (

    canonicalModel +

    " " +

    remainder

  ).trim();



}



  /* =========================================================

     ATTACH FORMS

     ========================================================= */



  function attachForms() {



    /*

     HOME search

     +

     Search result page search

    */



    var forms =

  document.querySelectorAll(

    ".ante-home-search form, .main-search-form, .ante-between-search__form, #predictive-search-form"

  );





    forms.forEach(function (form) {



      if (

        form.dataset.anteSearchV6 === "true"

      ) {

        return;

      }





      form.dataset.anteSearchV6 =

        "true";





      form.addEventListener(

        "submit",

        function () {



          var input =

            form.querySelector(

              'input[name="q"]'

            );





          if (!input) return;





          var raw =

            input.value.trim();





          if (!raw) return;





          /*
           * ANTE V6.2.2
           * Japanese / English recognized model searches keep the exact input.
           * Korean / Chinese-script aliases bridge to the canonical query.
           */
          var bridgeAnalysis =
            analyze(raw);

          var needsLanguageBridge =
            /[\uAC00-\uD7AF]/.test(raw) ||
            /[\u3400-\u9FFF]/.test(raw);

          var converted;

          if (
            bridgeAnalysis &&
            bridgeAnalysis.model
          ) {
            if (needsLanguageBridge) {
              /*
               * All-model multilingual bridge:
               * the dictionary already owns the model canonical name,
               * so Korean / Chinese aliases can use it directly.
               */
              if (bridgeAnalysis.model.id === "tank-americaine") {
                converted = "タンクアメリカン";
              } else {
                converted =
                  bridgeAnalysis.model.canonical ||
                  buildQuery(raw);
              }
            } else {
              converted = raw;
            }
          } else {
            converted = buildQuery(raw);
          }




          /*

           IMPORTANT:

           Do not preventDefault.

           Do not manually create URL.

           Shopify handles locale / Markets.

          */



          /*
           * ANTE V6.2.11 - FRANCK MULLER BRAND BRIDGE
           * analyze() does not return brands, so resolve the brand directly
           * from dictionary.brands. Japanese / English input stays unchanged.
           */
          if (needsLanguageBridge) {
            var anteDictionary =
              window.ANTE_SEARCH_DICTIONARY || null;

            var anteBrands =
              anteDictionary &&
              Array.isArray(anteDictionary.brands)
                ? anteDictionary.brands
                : [];

            var normalizedRawBrand =
              normalize(raw);

            var matchedFranckBrand =
              anteBrands.some(function (brand) {
                if (!brand || brand.id !== "franck-muller") {
                  return false;
                }

                var brandTerms = [];

                if (Array.isArray(brand.aliases)) {
                  brandTerms =
                    brandTerms.concat(brand.aliases);
                }

                if (brand.canonical) {
                  brandTerms.push(brand.canonical);
                }

                return brandTerms.some(function (term) {
                  return normalize(term) === normalizedRawBrand;
                });
              });

            if (matchedFranckBrand) {
              converted = "Franck Muller";
            }
          }



          input.value =

            converted;



        },

        true

      );



    });



  }





  /*
   * ============================================================
   * ANTE V6.2.11 - FINAL VISIBLE COUNT
   * ============================================================
   * Runs after page load for every search route, including brand
   * and dedicated collection routes.
   */
  function updateFinalVisibleCount() {
    var primaryProductList =
      document.querySelector(
        ".main-search product-list.product-list"
      );

    var cards =
      primaryProductList
        ? primaryProductList.querySelectorAll(
            ".ante-search-result"
          )
        : document.querySelectorAll(
            ".ante-search-result"
          );

    if (!cards.length) return;

    var count = 0;

    cards.forEach(function (card) {
      if (
        !card.hidden &&
        window.getComputedStyle(card).display !== "none"
      ) {
        count++;
      }
    });

    var resultTexts =
      document.querySelectorAll(
        ".section-header.justify-self-center.text-center .v-stack > p"
      );

    var params =
      new URLSearchParams(window.location.search);

    var query =
      params.get("ante_q") ||
      params.get("q") ||
      "";

    var lang =
      (document.documentElement.lang || "")
        .toLowerCase();

    resultTexts.forEach(function (element) {
      if (lang.indexOf("ja") === 0) {
        element.textContent =
          "「" + query + "」の検索結果：" +
          count + "件表示中";
      } else if (lang.indexOf("ko") === 0) {
        element.textContent =
          '"' + query + '" 검색 결과: ' +
          count + "개";
      } else if (lang.indexOf("zh") === 0) {
        element.textContent =
          "“" + query + "” 搜尋結果:" +
          count + "件";
      } else {
        element.textContent =
          'Search results for "' + query +
          '": ' + count + " shown";
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        window.setTimeout(updateFinalVisibleCount, 0);
      }
    );
  } else {
    window.setTimeout(updateFinalVisibleCount, 0);
  }


  /* =========================================================

     DEBUG

     ========================================================= */



  window.ANTESearch = {



    normalize: normalize,



    analyze: analyze,



    build: buildQuery



  };





  /* =========================================================

     INIT

     ========================================================= */



  function init() {



    attachForms();



  }





  if (

    document.readyState === "loading"

  ) {



    document.addEventListener(

      "DOMContentLoaded",

      init

    );



  }



  else {



    init();



  }



})();

/*

 * ============================================================

 * ANTE SEARCH RESULT MODEL GUARD V2

 * ============================================================

 *

 * Shopify検索が本文などから別モデルを拾った場合、

 * 商品タイトルをANTE辞書で解析して、

 * 検索したモデルと一致する商品だけを残す。

 *

 * V6本体とは独立して動作。

 * ============================================================

 */



(function () {

  "use strict";



  function normalize(value) {

    if (!value) return "";



    return String(value)
      .normalize("NFKC")
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[・･\-‐‑‒–—―_]/g, "")
      .replace(/[."'’`]/g, "")
      .trim();

  }





  function getCandidates(item) {

    var values = [];



    if (item && Array.isArray(item.aliases)) {

      values = item.aliases.slice();

    }



    if (item && item.canonical) {

      values.push(item.canonical);

    }



    return values;

  }





  function findModel(text, models) {

    if (!text || !Array.isArray(models)) {

      return null;

    }



    var target = normalize(text);

    var best = null;

    var bestLength = 0;



    models.forEach(function (model) {



      getCandidates(model).forEach(function (alias) {



        var candidate = normalize(alias);



        if (

          candidate &&

          target.indexOf(candidate) !== -1 &&

          candidate.length > bestLength

        ) {

          best = model;

          bestLength = candidate.length;

        }



      });



    });



    return best;

  }





  function getRequestedModel() {

    if (

      !window.ANTESearch ||

      typeof window.ANTESearch.analyze !== "function"

    ) {

      return null;

    }



    var params =

      new URLSearchParams(window.location.search);



    var query =

      params.get("ante_q") ||

      params.get("q") ||

      "";



    if (!query) return null;



    var analysis =

      window.ANTESearch.analyze(query);



    return analysis && analysis.model

      ? analysis.model

      : null;

  }





  function filterResults() {

    var dictionary =

      window.ANTE_SEARCH_DICTIONARY;



    if (

      !dictionary ||

      !Array.isArray(dictionary.models)

    ) {

      return;

    }



    var requestedModel =

      getRequestedModel();



    /*
     * ANTE COLLECTION ROUTE BYPASS
     *
     * main-search.liquid already selected the exact collection for
     * these dedicated routes. Do not re-filter those cards by the
     * translated product title.
     */
    var collectionRoutedModelIds = [
      "must-tank",
      "pre-must-tank",
      "panthere",
      "santos-demoiselle",
      "tank-francaise",
      "baignoire",
      "tank-louis"
    ];

    if (
      requestedModel &&
      collectionRoutedModelIds.indexOf(requestedModel.id) !== -1
    ) {
      var routedCards =
        document.querySelectorAll(".ante-search-result");

      routedCards.forEach(function (card) {
        card.hidden = false;
        card.style.removeProperty("display");
        card.removeAttribute("data-ante-filtered");
      });

      return;
    }



    /*

     ブランド検索・型番検索など、

     モデルが確定していない場合は何もしない。

    */

    if (!requestedModel) {

      return;

    }



    var cards =

      document.querySelectorAll(

        ".ante-search-result"

      );



    if (!cards.length) {

      return;

    }



    var visibleCount = 0;



    cards.forEach(function (card) {



      var title =

        card.getAttribute(

          "data-ante-product-title"

        ) || "";



      var productModel =

        findModel(

          title,

          dictionary.models

        );



      /*

       * 検索モデルと商品タイトルのモデルが

       * 一致した場合だけ残す。

       */



    /*

 * ============================================================

 * ANTE BROAD MODEL SEARCH

 * ============================================================

 *

 * 広い検索語:

 * Tank / タンク

 * Reverso / レベルソ

 * Santos / サントス

 * Allongee / Allongée / アロンジェ

 *

 * → タイトルにそのファミリー名を含む商品を広く残す。

 *

 * 具体的なモデル:

 * Tank Louis

 * Must Tank

 * Reverso Duetto

 * Santos Galbee

 *

 * → 従来どおりモデルID完全一致。

 */



var params =

  new URLSearchParams(

    window.location.search

  );



var rawSearch =

  (

    params.get("ante_q") ||

    params.get("q") ||

    ""

  ).trim();



var normalizedSearch =

  normalize(rawSearch);



var normalizedTitle =

  normalize(title);



var shouldShow = false;





/*

 * TANK FAMILY

 *

 * タンク / Tank 単独検索の場合のみ広く検索。

 *

 * Tank Louisなど具体的なモデル検索には

 * このルールを適用しない。

 */



if (

  normalizedSearch === "tank" ||

  normalizedSearch === "タンク"

) {



  shouldShow =

    normalizedTitle.indexOf("tank") !== -1 ||

    normalizedTitle.indexOf("タンク") !== -1;



}





/*

 * REVERSO FAMILY

 *

 * レベルソ / Reverso

 * → Duetto / Classiqueなども含め、

 * Reverso系をすべて表示。

 */



else if (

  normalizedSearch === "reverso" ||

  normalizedSearch === "レベルソ"

) {



  shouldShow =

    normalizedTitle.indexOf("reverso") !== -1 ||

    normalizedTitle.indexOf("レベルソ") !== -1;



}





/*

 * SANTOS FAMILY

 *

 * サントス / Santos

 * → Galbee / Octagon / Demoiselle /

 * Dumontなどを含める。

 */



else if (

  normalizedSearch === "santos" ||

  normalizedSearch === "サントス"

) {



  shouldShow =

    normalizedTitle.indexOf("santos") !== -1 ||

    normalizedTitle.indexOf("サントス") !== -1;



}





/*

 * ALLONGEE

 *

 * Baignoire Allongeeだけに限定しない。

 *

 * Tank Allongee

 * Baignoire Allongee

 * その他Allongee表記

 *

 * → すべて表示。

 */



else if (

  normalizedSearch === "allongee" ||

  normalizedSearch === "allonge" ||

  normalizedSearch === "アロンジェ"

) {



  shouldShow =

    normalizedTitle.indexOf("allongee") !== -1 ||

    normalizedTitle.indexOf("allonge") !== -1 ||

    normalizedTitle.indexOf("アロンジェ") !== -1;



}





/*

 * SPECIFIC MODEL

 *

 * Tank Louis

 * Must Tank

 * Reverso Duetto

 * Santos Galbee

 * etc.

 *

 * → モデルID完全一致。

 */



else {



  shouldShow =

    productModel &&

    productModel.id === requestedModel.id;



}

/*

 * ============================================================

 * FINAL BROAD SEARCH OVERRIDE

 * ============================================================

 *

 * 広いモデル名で検索した場合は、

 * 派生モデルも含めてタイトルベースで残す。

 */



var broadSearchRules = [



  {

    queries: ["tank", "タンク"],

    titleTerms: ["tank", "タンク"]

  },



  {

    queries: ["reverso", "レベルソ"],

    titleTerms: ["reverso", "レベルソ"]

  },



  {

    queries: ["santos", "サントス"],

    titleTerms: ["santos", "サントス"]

  },



  {

    queries: [

      "panthere",

      "panthère",

      "パンテール"

    ],

    titleTerms: [

      "panthere",

      "panthère",

      "パンテール"

    ]

  },



  {

    queries: ["must", "マスト"],

    titleTerms: ["must", "マスト"]

  },



  {

    queries: [

      "baignoire",

      "ベニュワール"

    ],

    titleTerms: [

      "baignoire",

      "ベニュワール"

    ]

  },



  {

    queries: [

      "allongee",

      "allonge",

      "allongée",

      "アロンジェ"

    ],

    titleTerms: [

      "allongee",

      "allonge",

      "allongée",

      "アロンジェ"

    ]

  }



];





broadSearchRules.forEach(

  function (rule) {



    var isBroadSearch =

      rule.queries.some(

        function (query) {

          return (

            normalizedSearch ===

            normalize(query)

          );

        }

      );



    if (!isBroadSearch) {

      return;

    }





    var titleMatches =

      rule.titleTerms.some(

        function (term) {

          return (

            normalizedTitle.indexOf(

              normalize(term)

            ) !== -1

          );

        }

      );





    if (titleMatches) {

      shouldShow = true;

    }



  }

);

     if (shouldShow) {



  card.hidden = false;

  card.style.removeProperty("display");



  card.removeAttribute(

    "data-ante-filtered"

  );



  visibleCount++;



}



else {



  card.hidden = true;



  card.style.setProperty(

    "display",

    "none",

    "important"

  );



  card.setAttribute(

    "data-ante-filtered",

    "true"

  );



}



    });



    document.documentElement.setAttribute(

      "data-ante-requested-model",

      requestedModel.id

    );

    /*
     * ANTE V6.2.7 VISIBLE RESULT COUNT
     * Count only cards that remain visible after MODEL GUARD.
     * This prevents Shopify's broad raw-search count from being shown.
     */
    var finalVisibleCount = 0;

    cards.forEach(function (card) {
      if (
        !card.hidden &&
        window.getComputedStyle(card).display !== "none"
      ) {
        finalVisibleCount++;
      }
    });

    document.documentElement.setAttribute(
      "data-ante-visible-count",
      String(finalVisibleCount)
    );



  /*

 * ============================================================

 * ANTE SEARCH RESULT DISPLAY

 * ============================================================

 *

 * Shopifyの元検索件数ではなく、

 * 現在ANTE判定で表示している件数を案内する。

 */



var resultTexts =

  document.querySelectorAll(

    ".section-header.justify-self-center.text-center .v-stack > p"

  );



resultTexts.forEach(function (element) {



  var queryParams =

    new URLSearchParams(

      window.location.search

    );



  var originalQuery =

    queryParams.get("ante_q") ||

    queryParams.get("q") ||

    "";



  var isJapanese =

    (

      document.documentElement.lang || ""

    )

      .toLowerCase()

      .indexOf("ja") === 0;



  if (isJapanese) {



    element.textContent =

      "「" +

      originalQuery +

      "」の検索結果:" +

      visibleCount +

      "件表示中";



  }



  else {



    element.textContent =

      'Search results for "' +

      originalQuery +

      '": ' +

      visibleCount +

      " shown";



  }



});

  }





  function init() {

    if (

      !document.querySelector(

        ".ante-search-result"

      )

    ) {

      return;

    }



    filterResults();

  }





  if (document.readyState === "loading") {



    document.addEventListener(

      "DOMContentLoaded",

      init

    );



  }



  else {



    init();



  }



})();
